import { noop } from "lodash";
import { stringifyUrl } from "query-string";
import React from "react";
import classNames from "../utils/classNames";
import { avatarsApi } from "../utils/constants";
import { formatHotspotName, formatHotspotPlace } from "../utils/hotspotUtils";
import { Hotspot } from "../utils/types";
import StatusDot from "./StatusDot";

interface Props {
  className?: string;
  hotspot: Hotspot;
  handleOnClick?: (walletAddress: string) => void;
  withoutAvatarInMobile?: boolean;
  style?: React.CSSProperties;
}

const HotspotComponent: React.FC<Props> = ({
  className,
  hotspot,
  handleOnClick,
  withoutAvatarInMobile,
  ...props
}) => (
  <div
    className={classNames(
      "relative flex items-center",
      handleOnClick && "cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700",
      withoutAvatarInMobile
        ? "px-0 sm:px-6 py-3 sm:py-5 space-x-0 sm:space-x-3"
        : "px-6 py-5 space-x-3",
      className
    )}
    onClick={handleOnClick ? () => handleOnClick(hotspot.owner) : noop}
    {...props}
  >
    <div
      className={classNames(
        withoutAvatarInMobile && "hidden sm:block",
        "flex-shrink-0 flex items-center"
      )}
    >
      <span className="inline-block relative">
        <img
          className="h-10 w-10 rounded-full"
          src={stringifyUrl({
            url: `${avatarsApi}/bottts/${hotspot.id}.svg`,
            query: { w: 40, h: 40 }
          })}
          alt="Hotspot avatar"
        />
        <StatusDot
          hotspot={hotspot}
          className="absolute top-0 right-0 block"
          withoutTooltip
        />
      </span>
    </div>
    <div className="flex-1 min-w-0 focus:outline-none">
      <span className="absolute inset-0" />
      <p className="text-sm font-medium text-gray-900 dark:text-gray-50 truncate">
        {formatHotspotName(hotspot as any)}
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-400 truncate">
        {formatHotspotPlace(hotspot.place)}
      </p>
    </div>
  </div>
);

export default HotspotComponent;
